<nb-card class="content-card" [nbSpinner]="!ready">
  <nb-card-body>
    <div class="col-md-12">
      <form [formGroup]="organizationForm" class="row" *ngIf="organizationForm">
        <div class="col-12">
          <h6 class="my-3">Organization information</h6>
          <nb-form-field class="my-2">
            <nb-select
              formControlName="country"
              placeholder="Country"
              fullWidth
              [status]="organizationForm.controls['country'].errors && organizationForm.controls['country'].dirty ? 'danger' : 'basic'"
            >
              <nb-option value="" *ngIf="!organizationForm.value.country">
                <div class="d-flex flex-center">Select</div>
              </nb-option>
              <nb-option *ngFor="let country of countries" [value]="country.iso2">
                <div class="d-flex flex-center"><img [src]="country.flag" /> {{ country.name }}</div>
              </nb-option>
            </nb-select>
          </nb-form-field>

          <!-- <nb-form-field class="my-2">
                        <nb-select formControlName="industry_sector_id" placeholder="Industry sector" fullWidth [status]="organizationForm.controls['industry_sector_id'].errors && organizationForm.controls['industry_sector_id'].dirty ? 'danger' : 'basic'">
                            <nb-option *ngFor="let sector of industrySectors$ | async" [value]="sector.id">
                                <div class="d-flex flex-center">
                                    {{ sector.label }}
                                </div>
                            </nb-option>
                        </nb-select>
                    </nb-form-field> -->

          <nb-form-field class="my-2">
            <nb-select
              formControlName="company_type"
              placeholder="Entity type"
              fullWidth
              [status]="organizationForm.controls['company_type'].errors && organizationForm.controls['company_type'].dirty ? 'danger' : 'basic'"
            >
              <nb-option *ngFor="let type of entityTypes" [value]="type.value">
                <div class="d-flex flex-center">
                  {{ type.name }}
                </div>
              </nb-option>
            </nb-select>
          </nb-form-field>
          <nb-form-field class="my-2">
            <mat-icon nbPrefix> cases</mat-icon>
            <input
              formControlName="company_name"
              [type]="'text'"
              nbInput
              fullWidth
              placeholder="Business legal name"
              [status]="organizationForm.controls['company_name'].errors && organizationForm.controls['company_name'].dirty ? 'danger' : 'basic'"
            />
          </nb-form-field>
          <nb-form-field class="my-2">
            <mat-icon nbPrefix> alternate_email</mat-icon>
            <input
              formControlName="company_email"
              [type]="'email'"
              nbInput
              fullWidth
              placeholder="Organization email"
              [status]="organizationForm.controls['company_email'].errors && organizationForm.controls['company_email'].dirty ? 'danger' : 'basic'"
            />
          </nb-form-field>
          <span *ngIf="organizationForm.controls['company_email'].errors && organizationForm.controls['company_email'].dirty"> Email is invalid </span>
          <!-- <nb-form-field class="my-2">
                        <mat-icon nbPrefix> phone</mat-icon>
                        <input formControlName="company_phone" ngxPhoneNumberInput type="phone" nbInput fullWidth placeholder="Business phone number" [status]="organizationForm.controls['company_phone'].errors && organizationForm.controls['company_phone'].dirty ? 'danger' : 'basic'"
                        />
                    </nb-form-field>
                    <div class="validation-error" *ngIf="
            organizationForm.controls['company_phone'].errors &&
            organizationForm.controls['company_phone'].dirty &&
            organizationForm.controls['company_phone'].errors.invalidPhoneNumber
          ">
                        Phone is invalid, should start with country code.
                    </div> -->
          <!-- <nb-form-field class="my-2">
                        <mat-icon nbPrefix> location_pin</mat-icon>
                        <input formControlName="company_address" [type]="'text'" nbInput fullWidth placeholder="legal address" [status]="organizationForm.controls['company_address'].errors && organizationForm.controls['company_address'].dirty ? 'danger' : 'basic'" />
                    </nb-form-field>
                    <nb-form-field class="my-2">
                        <mat-icon nbPrefix> text_snippet</mat-icon>
                        <textarea formControlName="company_description" nbInput fullWidth placeholder="Description" [status]="organizationForm.controls['company_description'].errors && organizationForm.controls['company_description'].dirty ? 'danger' : 'basic'"></textarea>
                    </nb-form-field> -->
        </div>

        <div class="col-12 my-2">
          <button class="float-right col-12" fullWidth nbButton [status]="'primary'" [disabled]="!organizationForm.valid" (click)="save()">Save</button>
        </div>
      </form>
    </div>
  </nb-card-body>
</nb-card>

<nb-card class="content-card connect-stripe-card" *ngIf="organizationForm && showStripeConnection">
  <nb-card-body>
    <div class="title mb-3">
      <span>Payment processing</span>
      <nb-tag [status]="isConnected ? 'success' : 'primary'" appearance="outline" [text]="isConnected ? 'Connected' : 'Not connected'"></nb-tag>
    </div>
    <button class="mb-3" nbButton [status]="'primary'" [disabled]="isConnected" (click)="redirectToStripe()" fullWidth>Connect Stripe Account</button>
    <span class="small text-black-50"
      >If you do not have a Stripe account <a (click)="requestOtherPaymentProvider()" class="font-weight-bold">click here</a> to enable other options relevant to the country of
      your organization
    </span>
  </nb-card-body>
</nb-card>
